import React from 'react'
import PropTypes from "prop-types"
import Component from "./Component";

class TextArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.getValue()
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.valueDidUpdate(prevProps)) {
      this.setState({
        value: this.getValue()
      });
    }
  }

  render() {
    return (
      <label className={"field has-float-label loadable " + (this.props.className || "")}>
        <textarea
          id={this.props.id}
          name={this.props.id}
          value={this.state.value}
          disabled={this.props.disabled}
          maxLength={this.props.maxLength || undefined}
          placeholder=" "
          rows={this.props.rows}
          cols={this.props.cols}
          className={this._getClass()}
          onChange={this.onChange.bind(this)}
          onBlur={this.onBlur.bind(this)}/>
        <span>{this.props.label}</span>
        <div className="error-icon fz fz-exclamation-triangle solid">
          <div className="has-tooltip danger" data-tooltip={this.errorMessage()}/>
        </div>
      </label>
    )
  }

  onChange(event) {
    this.setState({
      value: event.target.value
    });
    super.onChange(event);
  }

  _getClass() {
    return "input scrollbar" + (this.props.isInvalid || this.isInvalid() ? " is-invalid" : "") + (this.props.resize ? " " + this.props.resize : "");
  }
}

TextArea.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  rows: PropTypes.number,
  cols: PropTypes.number,
  resize: PropTypes.oneOf(["vertical", "horizontal", "none"]),
  className: PropTypes.string,
  label: PropTypes.string,
  isInvalid: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  formField: PropTypes.object,
  maxLength: PropTypes.number,
};


export default TextArea
